import React, { useEffect, useRef, useState } from "react";

import "../scrollBar.css";
import { Dropdown } from "react-bootstrap";
import { productService } from "../../services/product.service";
import "../../components/AddProduct.css";
import ProductAddModal from "./ProductAddModal";
import Card from "@mui/material/Card";
import {
  ResetPlanEdit,
  SetProductList,
  GetProductList,
} from "../../store/productAtom";

function ProductslideScroll(props) {
  const setProductList = SetProductList();
  const getProductList = GetProductList();
  const isMounted = useRef(false);


  useEffect(() => {
  isMounted.current = true;

  if (getProductList?.length === 0) {
    // 1. No data yet, fetch it
    productService.getAllProducts().then((res) => {
      if (res.data !== undefined && res.data.length > 0 && isMounted.current) {
        setProductList(res.data);
        props.viewItemDetails(res.data[0]);
      }
    });
  } else if (getProductList?.length > 0) {
    // 2. Data already exists in the global store
    // Ensure we don't overwrite the user's selection if they already selected something
    if (!props.selectedProduct || !props.selectedProduct.Product_Id) {
      props.viewItemDetails(getProductList[0]);
    }
  }

  return () => {
    isMounted.current = false;
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

  function getAllProduct() {
    productService.getAllProducts().then((res) => {
      if (res.data !== undefined) {
        setProductList(res.data);
        props.viewItemDetails(res.data[0]);
      }
    });
  }

  function reloadProductList() {
    getAllProduct();
  }

  return (
    <>
      <section className="py-4 border rounded-lg bg-white border-gray-200 flex flex-col overflow-y-auto h-[300px] lg:h-[1000px] scrollbar-thumb-gray-500 scrollbar-thin scrollbar-track-gray-100 pb-[100px] max-w-4xl w-full mx-auto">
        <div className="px-3 grid grid-cols-2 lg:grid-cols-1 gap-4">
          <div>
            <ProductAddModal reloadProductList={reloadProductList} />
          </div>
        </div>

        <div className="mt-6 px-3 space-y-4">
          {getProductList?.map((product, i) => (
            <Card
              key={i}
              className={`w-full cursor-pointer px-4 py-2 rounded-md border-y border-gray-200 overflow-hidden shadow-none border-r border-r-gray-200 ${
                props?.selectedProduct.Product_Id === product?.Product_Id
                  ? "border-l-4 border-l-blue-500"
                  : "border-l-4 border-gray-200 hover:bg-gray-100"
              }`}
              onClick={() => props.viewItemDetails(product)}
            >
              <p className="text-gray-800 font-bold text-base">
                {product?.Product_Name}
              </p>
              <div className="grid grid-cols-3 gap-4 text-center">
                <div>
                  <span className="text-gray-800 text-sm font-semibold">
                    {product?.Total_Plans}
                  </span>
                  <br />
                  <span className="text-gray-500 text-xs font-medium">
                    Plans
                  </span>
                </div>
                <div>
                  <span className="text-gray-800 text-sm font-semibold">
                    {product?.Total_Addons}
                  </span>
                  <br />
                  <span className="text-gray-500 text-xs font-medium">
                    Add-ons
                  </span>
                </div>
                <div>
                  <span className="text-gray-800 text-sm font-semibold">
                    {product?.Total_Coupons}
                  </span>
                  <br />
                  <span className="text-gray-500 text-xs font-medium">
                    Coupons
                  </span>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </section>
    </>
  );
}

export default ProductslideScroll;
